import { toast } from 'react-toastify';

export const TOAST_CONFIG = {
  AUTO_CLOSE: 3000,
  POSITION: 'top-right' as const,
  PASSWORD_COPIED_TIMEOUT: 2000,
} as const;

export function showSuccessToast(message: string, options?: { autoClose?: number }) {
  return toast.success(message, {
    position: TOAST_CONFIG.POSITION,
    autoClose: options?.autoClose ?? TOAST_CONFIG.AUTO_CLOSE,
  });
}

export function showErrorToast(message: string, options?: { autoClose?: number }) {
  return toast.error(message, {
    position: TOAST_CONFIG.POSITION,
    autoClose: options?.autoClose ?? TOAST_CONFIG.AUTO_CLOSE,
  });
}
